<template>
    <Overlay :show="showLoading">
        <b-card>
            <b-row>
                <b-col class="d-flex align-items-center justify-content-between">
                    <StatusBadge :submission="submission"/>
                    <div>
                        <Button
                            class="ml-1"
                            @click="back"
                        >
                            {{ $t('Component(Button):back') }}
                        </Button>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2 pt-1">
                <b-col >
                    <h2 class="float-left pr-1">
                        {{ $t('Page(SubmissionCard):Component(Label):page-label') }}
                    </h2>
                </b-col>
            </b-row>

            <b-tabs justified>
                <b-tab :title="$t('Page(SubmissionCard):Component(Tab):general')" class="pt-1">
                    <b-row class="pb-50">
                        <b-col md="4" sm="5" lg="3">{{ $t('Component(Label):submission-number') }}</b-col>
                        <b-col md="8" sm="7" lg="9">{{ submission.number }}</b-col>
                    </b-row>
                    <b-row class="pb-50">
                        <b-col md="4" sm="5" lg="3">{{ $t('Component(Label):scip-number') }}</b-col>
                        <b-col md="8" sm="7" lg="9">{{ submission.scipNumber }}</b-col>
                    </b-row>
                    <b-row class="pb-50">
                        <b-col md="4" sm="5" lg="3">{{ $t('Component(Label):dossier-uuid') }}</b-col>
                        <b-col md="8" sm="7" lg="9">{{ submission.dossierUuid }}</b-col>
                    </b-row>
                    <b-row class="pb-50">
                        <b-col md="4" sm="5" lg="3">{{ $t('Component(Label):product-name') }}</b-col>
                        <b-col md="8" sm="7" lg="9">{{ productTitle }}</b-col>
                    </b-row>

                    <b-row class="pb-50">
                        <b-col md="4" sm="5" lg="3">{{ $t('Component(Label):created-at') }}</b-col>
                        <b-col md="8" sm="7" lg="9">{{ renderDateTime(submission.createdAt) }}</b-col>
                    </b-row>

                    <b-row class="pb-50">
                        <b-col md="4" sm="5" lg="3">{{ $t('Component(Label):updated-at') }}</b-col>
                        <b-col md="8" sm="7" lg="9">{{ renderDateTime(submission.updatedAt) }}</b-col>
                    </b-row>
                </b-tab>
                <b-tab :title="$t('Page(SubmissionCard):Component(Tab):snapshot')">
                    <ArticleTree
                        :article="submission.snapshot"
                        :readonly="true"
                        @change="onArticleChange"
                    />
                </b-tab>
            </b-tabs>
        </b-card>
    </Overlay>
</template>
<script>
import Overlay from "@core/components/common/Overlay.vue";
import {ProductProvider} from "@core/domain/product";
import { BCard, BRow, BCol, BTabs, BTab } from 'bootstrap-vue'
import ArticleTree from "@/views/product/components/scip-notification/ArticleTree.vue";
import Button from "@core/components/common/Button.vue";
import backendResponse from "@core/mixins/ui/backend-response";
import {ProductApi} from "@core/api";
import StatusBadge from "@/views/product/scip-notification/StatusBadge.vue";
import dateRenderer from "@core/mixins/date-renderer";
export default {
    mixins: [backendResponse, dateRenderer],
    components: {
        StatusBadge, BCard, Button, Overlay, BRow, BCol, ArticleTree, BTabs, BTab
    },
    props: {
        id: {
            required: true
        }
    },
    data() {
        return {
            showLoading: true,
            isSubmissionButtonDisabled: true,
            previousArticle: null,
            gatherFactsTimeout: null,
            submission: {
                number: '',
                product: {
                    names: [],
                },
                snapshot: {
                    availableNames: [],
                    categories: [],
                    safeUseInstructions: null,
                    scipSettings: {
                        productionFlag: null
                    },
                    isExcluded: false,
                    scipName: '',
                    primaryIdentifier: {
                        value: ''
                    },
                    primaryName: {
                        value: ''
                    },
                    children: [],
                    concernElements: [],
                }
            }
        };
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        gotoScipNotificationOverview() {
            this.$router.push({
                name: 'submission-overview'
            })
        },
        onArticleChange() {
            if (false === this.isSubmissionButtonDisabled) {
                return;
            }
            clearTimeout(this.gatherFactsTimeout);
            this.gatherFactsTimeout = setTimeout(() => {
                ProductProvider(this.id)
                    .getSCIPNotificationFacts()
                    .then(facts => {
                        this.isSubmissionButtonDisabled = !facts.isNotificationGranted;
                    })
            }, 500);
        },
        gatherFactsAndProcess() {
            ProductProvider(this.id)
                .getSCIPNotificationFacts()
                .then(facts => {
                    if (facts.isNotificationGranted) {
                        this.isSubmissionButtonDisabled = false;
                    }
                    // if (false === facts.isNotificationGranted) {
                    //     this.$router.push({
                    //         name: 'product-card',
                    //         params: {id: this.id}
                    //     })
                    // } else {
                        this.init();
                    // }
                })
        },
    },
    computed: {
        productTitle() {
            if (this.submission.product.names.length === 0) {
                return ''
            }

            return this.submission.product.names[0].value;
        }
    },
    created() {
        ProductApi
            .getSubmissionCard(this.id)
            .then(r => this.submission = r.data)
            .finally(() => this.showLoading = false)
        ;
    },
}
</script>
